/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 添加外部会员卡
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  memberCardReq: member.MemberCardReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/cards/add/outer`,
    data: memberCardReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
